import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TrailDpSensor } from '../dto/trail-dp-sensor';

@Injectable({
  providedIn: 'root'
})
export class TrailDpSensorService {

  private apiUrl = environment.apiRoot + '/trialdpsensor';

  constructor(private http: HttpClient) { }

  getAllSetupOfTrial(trialId: number): Observable<TrailDpSensor[]> {
    return this.http.get<TrailDpSensor[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  createDpSensor(trialId: number): Observable<TrailDpSensor> {
    let model = { "id": 0, "trial_id": trialId, "name": "new DpSensor" };
    return this.http.post<TrailDpSensor>(this.apiUrl + '/new', model);
  }

  updateDpSensor(model: TrailDpSensor): Observable<TrailDpSensor> {
    return this.http.put<TrailDpSensor>(this.apiUrl + '/update', model);
  }

  deleteDpSensor(trialDpSensorId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?trialDpSensorId=' + trialDpSensorId);
  }

}
